export default [
    { key: 'menu.name', label: 'Menú' },
    { key: 'name', label: 'Nombre' },
    { key: 'slug', label: 'Slug' },
    { key: 'description', label: 'Descripción' },
    { key: 'order', label: 'Orden' },
    { key: 'to', label: 'Nombre de la página' },
    { key: 'actions', label: '' },
]